import React from "react";

const moreFeatures = [
  { title: "Editing Controls", body: "Crop, rotate, and apply a Black & White filter within the app.", icon: "crop" },
  { title: "Add QR Code", body: "Use your QR code as a watermark on your photographs.", icon: "qr" },
  { title: "Dark Mode", body: "Dark Mode support for iOS and Android.", icon: "moon" },
  { title: "Multilingual", body: "App is localized in 11 different languages.", icon: "globe" },
  { title: "Sleek & User Friendly", body: "Designed with a responsive and user-friendly approach.", icon: "sparkle" },
  { title: "High Resolution", body: "Watermark photos without compromising on quality.", icon: "hires" },
  { title: "Keeps EXIF Intact", body: "Maintains EXIF metadata after export.", icon: "exif" },
  { title: "Trusted by Millions", body: "Users trust our watermarking solution to protect their photos.", icon: "trust" },
  { title: "Multiple Export Options", body: "Export watermarked photos to various social platforms.", icon: "export" },
];

const MiniIcon: React.FC<{ name: string }> = ({ name }) => {
  const stroke = "currentColor";
  switch (name) {
    case "crop":
      return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round"><path d="M6 2v14a2 2 0 0 0 2 2h14" /><path d="M18 22V8a2 2 0 0 0-2-2H2" /></svg>;
    case "qr":
      return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><path d="M14 14h3v3h-3zM19 19h2v2h-2z" /></svg>;
    case "moon":
      return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" /></svg>;
    case "globe":
      return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20" /></svg>;
    case "sparkle":
      return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round"><path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5L18 18M18 6l-2.5 2.5M8.5 15.5L6 18" /></svg>;
    case "hires":
      return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M8 12h2v4M14 8v8M14 12h3" /></svg>;
    case "exif":
      return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6M9 13h6M9 17h4" /></svg>;
    case "trust":
      return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round"><path d="M12 2l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6z" /><path d="m9 12 2 2 4-4" /></svg>;
    case "export":
      return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" /></svg>;
    default:
      return null;
  }
};

const MoreCard: React.FC<{ title: string; body: string; icon: string; delay: number }> = ({
  title,
  body,
  icon,
  delay,
}) => {
  return (
    <div className="fp-more__card" style={{ animationDelay: `${delay}ms` }}>
      <div className="fp-more__glow" />
      <div className="fp-more__icon-wrap">
        <div className="fp-more__icon">
          <MiniIcon name={icon} />
        </div>
        <span className="fp-more__ring" />
      </div>
      <h3 className="fp-more__title">{title}</h3>
      <p className="fp-more__body">{body}</p>
      <div className="fp-more__link">
        Learn more <span aria-hidden="true">→</span>
      </div>
      <span className="fp-more__underline" />
    </div>
  );
};

const MoreFeaturesGrid: React.FC = () => {
  return (
    <section className="fp-more">
      <div className="fp-more__head">
        <span className="fp-more__eyebrow">More Features</span>
        <h2 className="fp-more__heading">
          <span className="lr-text-gradient">Revolutionize</span> the way you watermark.
        </h2>
        <p className="fp-more__lede">Exciting extras that make eZy Watermark feel effortless.</p>
      </div>

      <div className="fp-more__grid">
        {moreFeatures.map((f, i) => (
          <MoreCard key={f.title} title={f.title} body={f.body} icon={f.icon} delay={i * 80} />
        ))}
      </div>
    </section>
  );
};

export default MoreFeaturesGrid;
